import { render } from "./PartsButtonBlack.vue?vue&type=template&id=1959ea75&scoped=true"
import script from "./PartsButtonBlack.vue?vue&type=script&lang=js"
export * from "./PartsButtonBlack.vue?vue&type=script&lang=js"

import "./PartsButtonBlack.vue?vue&type=style&index=0&id=1959ea75&scoped=true&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1959ea75"]])

export default __exports__